import { createContext } from 'react';

const LancamentoContext = createContext();

export default LancamentoContext;
